import { Injectable } from '@angular/core';
import { UserManager, UserManagerSettings, User, WebStorageStateStore } from 'oidc-client';
import { ConfService } from 'src/conf.service';
import { ApiConfig } from '../config/apiConfig';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { LocalStorageService } from './session.service'
import {MessageService} from '../services/toaster/message.service'
import { Router } from '@angular/router';
import { throwError } from 'rxjs/internal/observable/throwError';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private rootUrl: string;
  private authAPIUrl;
  private manager = new UserManager(getClientSettings());
  private user: User = null;
  constructor(private http: HttpClient, private localService: LocalStorageService,private _messageService:MessageService,private _router: Router, ) {
    this.rootUrl = ConfService.conf.environment.apiRootUrl;
    this.authAPIUrl = ApiConfig.AuthApiConfig;
    console.log()
    this.manager.getUser().then(user => {
      this.user = user;
    });
  }

  isLoggedIn(): boolean {
    return this.user != null && !this.user.expired && this.localService.getItem("userInfo")!=null;
  }
  isTokenExpired():boolean
  {
    try
    {

    
    let expireTime=this.getFromSessionStorage("expires_at")
    if(expireTime==null || expireTime < new Date().getTime()/1000)
    {
      return true;
    }
    else
    {
      return false;
    }
  }
  catch(ex)
  {
    return true;
  }
}
  public async getUser(): Promise<User> {
    return await this.manager.getUser();
  }

  getClaims(): any {
    return this.user.profile;
  }

  getAuthorizationHeaderValue(): string {
    return `${this.user.token_type} ${this.user.access_token}`;
  }

  getUserIdToken(): string {
    return this.user.id_token;
  }

  startAuthentication(): Promise<void> {
    localStorage.setItem('currenturl', window.location.href);
    return this.manager.signinRedirect();
  }

  completeAuthentication(): Promise<void> {
    return this.manager.signinRedirectCallback().then(user => {
      //console.log(user);
      this.user = user;
      window.history.replaceState({},
        window.document.title,
        window.location.origin + window.location.pathname);
      }).catch(err => 
      {
        //console.log(`Error in completeAuthentication occured`);
        this._messageService.setErrorPageMessage('401:Error in completeAuthentication');
        this._router.navigate(['/error']);
      });;
  }

  getFromLocal(key): string {
    return localStorage.getItem(key);
  }

  getFromSessionStorage(key): any {
    const jsonOidc = localStorage.getItem(`oidc.user:${ConfService.conf.environment.oidcConfig.issuer}:${ConfService.conf.environment.oidcConfig.clientId}`)
    const sessionOidc = JSON.parse(jsonOidc);
    return sessionOidc[key];
  }

  getbartPrivs(authObj: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.authAPIUrl.bartPrivs}`, authObj)
      .pipe(
        tap(() => {
          //
        })
      );
  }

  signOut(): Promise<void> {    
    const refreshToken = this.getRefreshToken();
    this.revokeToken(refreshToken);
    return this.manager.signoutRedirect();
  }

  getRefreshToken(): string {
    if (this.user == null || this.user == undefined) {
      return this.getFromSessionStorage('refresh_token');
    }
    else {
      return this.user.refresh_token;
    }
  }
  
  private revokeToken(token: string) {
    console.log('Revoking token = ' + token);
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('token', token);
    urlSearchParams.append('token_type_hint', 'refresh_token');
    urlSearchParams.append('client_id', ConfService.conf.environment.oidcConfig.clientId);
    this.http.post(ConfService.conf.environment.oidcConfig.revocation_endpoint, urlSearchParams.toString(), { headers })
      .subscribe(result => {
        console.log('Access token and related refresh token (if any) have been successfully revoked');
      }, (error) => {
        console.error('Something went wrong on token revocation');
        // this.oidcSecurityService.handleError(error);
        return throwError(error);
      });
  }

  getServiceNowRequestUrl() {
    return ConfService.conf.environment.serviceNowUrl;
  }
}

export function getClientSettings(): UserManagerSettings {
  return {
    authority: ConfService.conf.environment.oidcConfig.issuer,
    client_id: ConfService.conf.environment.oidcConfig.clientId,
    redirect_uri: ConfService.conf.environment.oidcConfig.redirectURL,
    //post_logout_redirect_uri: ConfService.conf.environment.oidcConfig.post_logout_redirect_uri,
    response_type: "code",
    scope: "openid email profile address phone",
    filterProtocolClaims: true,
    loadUserInfo: false,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    response_mode:"query",
    revokeAccessTokenOnSignout:true,
    metadata: 
    {
      issuer: ConfService.conf.environment.oidcConfig.issuer,
      authorization_endpoint: ConfService.conf.environment.oidcConfig.authorization_endpoint,
      token_endpoint: ConfService.conf.environment.oidcConfig.token_endpoint,
      jwks_uri: ConfService.conf.environment.oidcConfig.jwks_uri,
      end_session_endpoint: ConfService.conf.environment.oidcConfig.end_session_endpoint,
      revocation_endpoint:ConfService.conf.environment.oidcConfig.revocation_endpoint,
      userinfo_endpoint: ConfService.conf.environment.oidcConfig.userinfo_endpoint,
    }
  };
}
